import InfoBanner from '../Common/CommonComponents/InfoBanner/InfoBanner.js';
import SceButton from "../Common/CommonComponents/SceButton/V1/sceButton";
import classes from "./SingleAccDboard/singleAccDboardContainer.scss";
const dashboardContainerHelper = {
        formatMailingAddress(mailingAddr) {
        let { careOfName, houseNumber, street, supplement, city, region, postalCode, poBox, poPostalCode } = mailingAddr,parts = [];
        return dashboardContainerHelper.getCommaSeparatedAddr([[careOfName?`C/O ${this.capitaliser(careOfName)}`:null],[poBox?`PO Box ${poBox}`:null],[houseNumber, this.capitaliser(street)],[supplement],[this.capitaliser(city)],[region, poPostalCode? this.capitaliser(poPostalCode.split('-')[0]):postalCode.split('-')[0]]]);
    },
    getTrueKeys(apiStatus) {
        return Object.keys(apiStatus).filter(key => apiStatus[key] === true);
    },
    navigateToFunc(){
        app.appUtil.navigateTo(app.appUtil.getAppRoutes().MYACCOUNT.MYACCOUNT_LANDINGPAGE);
    },
    displayGlobalError(errorTitle,errorMsg){
        let isMobile = app.appUtil.detectMobile(), isTablet = app.appUtil.FormatUtil.isTablet(), rightArrowIcon = drupalSettings.path.baseUrl + 'sites/default/files/react_images/Chevron--right.png', altText = "right-icon";
        let bannerType = 'warning-hex';
        return (
        <div className={classes.managePaymentContainerBox}>
            <div className={classes.managePaymentMethod}>  
                <InfoBanner primaryType={bannerType} primaryHeader={errorTitle} primaryMessage={errorMsg} />
                    <div className={classes.buttonStyling}>
                        <SceButton id="backtomyaccount" buttonType={isMobile || isTablet? 'sceSmPrimary':'scePrimary'} value={"Refresh"} onClick={this.navigateToFunc} iconSrc={rightArrowIcon} alt={altText} />
                    </div>
            </div>
        </div>
        );
    },
    formatMailingAddressPopup(mailingAddr) {    
        let firstLine = [],secondLine = [];
        // Add care of name
        if (mailingAddr.careOfName) {
            firstLine.push(this.capitaliser(mailingAddr.careOfName));}
    
        // Check if poBox is provided
        if (mailingAddr.poBox) {
            firstLine.push(`PO box ${mailingAddr.poBox}, `);
        } else {
            // Combine house number and street if poBox is not present
            if (mailingAddr.houseNumber && mailingAddr.street) {
                firstLine.push(`${mailingAddr.houseNumber} ${this.capitaliser(mailingAddr.street)}`);}
            else if(mailingAddr.houseNumber){
                firstLine.push(mailingAddr.houseNumber);
            }else if(mailingAddr.street){
                firstLine.push(this.capitaliser(mailingAddr.street));
            }
            // Add supplement if it exists
            if (mailingAddr.supplement) {
                firstLine.push(`${mailingAddr.supplement }, `);}
            else{firstLine.push("");}
            }
    
        // Build second line with city, region, and postal code
        if (mailingAddr.city) {
            secondLine.push(this.capitaliser(mailingAddr.city));}
        if (mailingAddr.region) {
            secondLine.push(`${mailingAddr.region} ${mailingAddr.poPostalCode?mailingAddr.poPostalCode.split('-')[0]:mailingAddr.postalCode.split('-')[0]}`);}
        
        
    
        return `${firstLine.join(', ')}\n${secondLine.join(', ')}`;
    },
    getCommaSeparatedAddr(fields) {
        let strs = [];
        for (let i=0; i<fields.length; i++) {
            let parts = [];
            for (let j=0; j<fields[i].length; j++)
                if (fields[i][j])
                    parts.push(fields[i][j]);
            if (parts.length){
                strs.push(parts.join(" "));
            }                
        }
        return strs.join(", ");
    },
    capitaliser (mySentence) {
        let words = mySentence?mySentence.trim().split(" "):[];
        mySentence?words.length <1 ? words.push(mySentence) : null:null;
        let reframedSentence = words.map((word) => {
            let reframed = word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
            return reframed;}).join(" ");
        return reframedSentence;
    },
    setGenericAccountTypeSession(response) {
        let { customerAccountListData, totalCustomerAccountCount } = response;
        let customerAccountListDataLength = customerAccountListData.length;
        let genericAccountType = "unknown" + " | " + totalCustomerAccountCount;
        let isCommercial = false;

        for (let i = 0; i < customerAccountListDataLength; i++) {
            const eligibilityData = customerAccountListData[i].eligibilityData;
            if (eligibilityData && eligibilityData[0] && 
                eligibilityData[0].customerClass !== app.appUtil.getAppConstants().CUSTOMER_CLASS
            ) {
                isCommercial = true;
                break;
            }
        }

        if (isCommercial) {
            genericAccountType = app.appUtil.getAppConstants().Business + " | " + totalCustomerAccountCount;
        }
        else if (totalCustomerAccountCount <= 10) {
            genericAccountType = app.appUtil.getAppConstants().residential + " | " + totalCustomerAccountCount;
        }

        app.appService.setLocalStorage('genericAccountType', genericAccountType);
    }
};
export default dashboardContainerHelper;
